import { routeDescriptions, fallbackDescription, humanizeCity } from '../seo/metadata'

function setMetaTag (name, content) {
  if (!content) return
  let el = document.head.querySelector(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setCanonical (url) {
  if (!url) return
  let link = document.head.querySelector('link[rel="canonical"]')
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }
  link.setAttribute('href', url)
}

function buildDescription (to) {
  const name = to.name
  let tpl = routeDescriptions[name]
  if (!tpl) return fallbackDescription

  if ((name === 'Lieferdienstauswahl' || name === 'Anbieter' || name === 'PizzaCity' || name === 'BurgerCity' || name === 'DoenerCity') && to.params.geoUrl) {
    const city = humanizeCity(to.params.geoUrl)
    if (city) tpl = tpl.replace('{CITY}', city)
  }
  return tpl
}

function buildTitle (to) {
  const base = window.baseTitle || 'foodi.de'
  let prefix = ''
  if (to.meta && to.meta.title) {
    prefix = to.meta.title
  } else if (to.name === 'Lieferdienstauswahl' || to.name === 'Anbieter') {
    const city = humanizeCity(to.params.geoUrl)
    if (city) prefix = `Essen bestellen in ${city}`
  } else if (to.name === 'PizzaCity' || to.name === 'BurgerCity' || to.name === 'DoenerCity') {
    const city = humanizeCity(to.params.geoUrl)
    const label = to.name.replace('City', '') // Pizza, Burger, Doener
    if (city) prefix = `${label} bestellen in ${city}`
  }
  return prefix ? `${prefix} • ${base}` : base
}

function injectWebSiteJsonLd () {
  if (document.head.querySelector('#seo-jsonld-website')) return
  const script = document.createElement('script')
  script.id = 'seo-jsonld-website'
  script.type = 'application/ld+json'
  const base = (window.location.origin || 'https://foodi.de')
  script.textContent = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    'name': 'foodi.de',
    'url': base + '/',
    'potentialAction': {
      '@type': 'SearchAction',
      'target': base + '/?q={search_term_string}',
      'query-input': 'required name=search_term_string'
    }
  })
  document.head.appendChild(script)
}

export function updateSEO (to) {
  // Titel
  document.title = buildTitle(to)
  // Meta Description
  setMetaTag('description', buildDescription(to))
  // Canonical
  const canonicalUrl = window.location.origin + to.fullPath
  setCanonical(canonicalUrl)
  // JSON-LD Basis sicherstellen
  injectWebSiteJsonLd()
  // Standard: index,follow (kann später über markNoindex überschrieben werden)
  setMetaTag('robots', 'index,follow')
}

// Setzt robots auf noindex,follow (für leere / temporär unerwünschte Seiten)
export function markNoindex () {
  setMetaTag('robots', 'noindex,follow')
}

// Setzt robots aktiv wieder auf index,follow wenn Content vorhanden
export function markIndex () {
  setMetaTag('robots', 'index,follow')
}



// WEBPACK FOOTER //
// ./src/utils/seo.js